module.exports = __webpack_public_path__ + "static/media/Location_Book-Page31.f2455caf.png";